import { createContext, useContext } from "react";

export const DevFormContext = createContext(null);
export const useDevFormContext = () => useContext(DevFormContext);
